import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { UserPage } from '../../components/UserPage';
import { Section } from '../../components/Section';


export const HelpPage: FC = () => {
    return (
        <UserPage title="Salon.jp | マップとは">
            <Section>
                <div className="content">
                    <h2>マップとは</h2>
                    <p>西野亮廣エンタメ研究所のサロンメンバーがいるお店を可視化したマップです。近くにお越しの際は、ぜひ立ち寄ってみてください。</p>
                </div>
                <div className="content">
                    <h2>サロンメンバー特典とは</h2>
                    <p>西野亮廣エンタメ研究所のサロンメンバーに限定して 提供されている特典です。</p>
                </div>
                <div className="content">
                    <h2>位置情報の利用を許可する方法</h2>
                    <p>
                        <Link to="/map/help/geolocation">
                            <a>詳しくはこちら</a>
                        </Link>
                    </p>
                </div>
                <div className="content">
                    <h2>何かあったら・・</h2>
                    <p>何かありましたら、<a href="/contacts/faq">こちら</a>からお問い合わせください。</p>
                </div>
            </Section>

            <style jsx>{`
                .content {
                    margin-bottom: 24px;
                }
                .content:nth-child(1) {
                    padding-top: 30px;
                }
                .content:nth-last-child(1) {
                    padding-bottom: 24px;
                    margin-bottom: 0px;
                }
                h1 {
                    font-weight: normal;
                    font-size: 20px;
                    margin: 0;
                }
                h2 {
                    font-size: 18px;
                    margin: 0;
                }
                a,
                p {
                    font-size: 16px;
                    margin: 0;
                }
                a {
                    color: #fe8125;
                }
                @media screen and (max-width: 540px) {
                    .title {
                        padding-top: 24px;
                        padding-bottom: 36px;
                    }
                    h2 {
                        font-size: 16px;
                    }
                    a,
                    p {
                        font-size: 14px;
                    }
                }
            `}</style>
        </UserPage>
    );
};
